/**
 * LANGUAGE
 */
export const STORE_LANGUAGE = 'STORE_LANGUAGE';

/**
 * ERROR -> error notification
 */
export const SHOW_NOTIFICATION_BAR = 'SHOW_NOTIFICATION_BAR';
export const CLOSE_NOTIFICATION_BAR = 'CLOSE_NOTIFICATION_BAR';
export const RESET_NOTIFICATION_BAR = 'RESET_NOTIFICATION_BAR';

/**
 * GLOBAL SEARCH
 */
export const GET_GLOBAL_SEARCH = 'GET_GLOBAL_SEARCH';

/**
 * NAVIGATION -> navigation module
 */
export const OPEN_NAVIGATION = 'OPEN_NAVIGATION';
export const CLOSE_NAVIGATION = 'CLOSE_NAVIGATION';
export const SET_ACTIVE_MENU = 'SET_ACTIVE_MENU';
export const OPEN_LEFT_NAVIGATION = 'OPEN_LEFT_NAVIGATION';
export const CLOSE_LEFT_NAVIGATION = 'CLOSE_LEFT_NAVIGATION';
export const SET_LEFT_ACTIVE_MENU = 'SET_LEFT_ACTIVE_MENU';

/**
 * SIDEBAR
 */
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const STORE_SIDEBAR_FIELDS = 'STORE_SIDEBAR_FIELDS';
export const CLEAR_SIDEBAR_FIELDS = 'CLEAR_SIDEBAR_FIELDS';

/**
  * FILTERS
  */
// communicate with API - api data
export const GET_FILTERS = 'GET_FILTERS';
export const SAVE_FILTERS = 'SAVE_FILTERS';
export const DELETE_FILTER = 'DELETE_FILTER';

// communicate with VUEX - local data
export const STORE_FILTERS = 'STORE_FILTERS';
export const UPDATE_EXISTING_FILTER = 'UPDATE_EXISTING_FILTER';

// new filter
export const SET_IS_CUSTOM_FILTER_NAME = 'SET_IS_CUSTOM_FILTER_NAME';
export const SET_IS_NEW_FILTER = 'SET_IS_NEW_FILTER';
export const EDIT_EXISTING_FILTER = 'EDIT_EXISTING_FILTER';
export const STORE_NEW_FILTER = 'STORE_NEW_FILTER';
export const REMOVE_EXISTING_FILTER_PARAM = 'REMOVE_EXISTING_FILTER_PARAM';
export const REMOVE_EXISTING_FILTER_ALL = 'REMOVE_EXISTING_FILTER_ALL';

export const STORE_ACTIVE_FILTER = 'STORE_ACTIVE_FILTER';
export const CLEAR_ACTIVE_FILTER = 'CLEAR_ACTIVE_FILTER';

export const RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';

// NEW DATA
export const STORE_FILTERS_MENU = 'STORE_FILTERS_MENU';
export const CLEAR_FILTERS_MENU = 'CLEAR_FILTERS_MENU';

// SEARCH
export const TABLE_SEARCH = 'TABLE_SEARCH';
export const STORE_SEARCH = 'STORE_SEARCH';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
